<template>
  <b-row>
    <b-col
      cols="12"
      md="6"
    >
      <h2>Telefones úteis</h2>
      <p>
        Veja a lista de telefones úteis.
      </p>
    </b-col>
    <b-col
      cols="12"
      class="mt-0"
    >
      <list-telefone-util />
    </b-col>
  </b-row>
</template>

<script>
import ListTelefoneUtil from './ListTelefoneUtil.vue'

export default {
  components: {
    ListTelefoneUtil,
  },
}
</script>
